// extracted by mini-css-extract-plugin
var _1 = "_vm7vb";
export { _1 as "link" }
